import { ContextModalProps } from '@mantine/modals'
import DeliveryCompanyForm from 'components/orders/DeliveryCompanyForm'
import { useUpdateDeliveryCompany } from 'hooks/orders'
import { DeliveryCompany } from 'types/orders'
import { isGuid } from 'utils'

type Props = {
  deliveryCompany: DeliveryCompany
}

export default function UpdateDeliveryCompanyModal({
  context,
  id,
  innerProps: { deliveryCompany },
}: ContextModalProps<Props>) {
  const updateDeliveryCompany = useUpdateDeliveryCompany()
  return (
    <DeliveryCompanyForm
      onClose={() => context.closeContextModal(id)}
      onSubmit={async (values) => {
        await updateDeliveryCompany.mutateAsync({
          ...values,
          id: deliveryCompany.id,
          shipmentTypes: values.shipmentTypes.map((type) => ({
            ...type,
            id: isGuid(type.id) ? type.id : '',
          })),
        })
      }}
      initialValues={deliveryCompany}
    />
  )
}
